import { render } from "./Footer.vue?vue&type=template&id=21a1f13e&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=21a1f13e&lang=scss&scoped=true"

import exportComponent from "/home/deploy/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a1f13e"]])

export default __exports__